"use strict";

var template = require("./rtGlobalSettings.html");

module.exports = /* @ngInject */ function() {
  return {
    restrict: "E",
    controller: "RtGlobalSettingsController",
    controllerAs: "ctrl",
    bindToController: true,
    scope: {},
    template: template
  };
};



// WEBPACK FOOTER //
// ./app/ui/directives/rtGlobalSettings/rtGlobalSettings.js